export type SecondaryMarketLiveInstantBookActions =
  | SecondaryMarketLiveInstantBookWorkflowInit
  | SecondaryMarketLiveInstantBookWorkflowAborted
  | SecondaryMarketLiveInstantBookWorkflowCompleted
  | SecondaryMarketLiveInstantBookWorkflowRequested
  | SecondaryMarketLiveInstantBookWorkflowReceived
  | SecondaryMarketLiveInstantBookWorkflowFailed
  | SecondaryMarketLiveInstantBookWorkflowRejected;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowInit(orderId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_WORKFLOW_INIT' as const,
    orderId,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowInit = ReturnType<typeof secondaryMarketLiveInstantBookWorkflowInit>;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowAborted(orderId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_WORKFLOW_ABORTED' as const,
    orderId,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowAborted = ReturnType<
  typeof secondaryMarketLiveInstantBookWorkflowAborted
>;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowCompleted(orderId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_WORKFLOW_COMPLETED' as const,
    orderId,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowCompleted = ReturnType<
  typeof secondaryMarketLiveInstantBookWorkflowCompleted
>;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowRequested(orderId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_REQUESTED' as const,
    orderId,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowRequested = ReturnType<
  typeof secondaryMarketLiveInstantBookWorkflowRequested
>;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowReceived(orderId: string) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_RECEIVED' as const,
    orderId,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowReceived = ReturnType<
  typeof secondaryMarketLiveInstantBookWorkflowReceived
>;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowFailed(orderId: string, error: string | undefined) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_FAILED' as const,
    orderId,
    error,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowFailed = ReturnType<
  typeof secondaryMarketLiveInstantBookWorkflowFailed
>;

/////////////////////////////////////////////
export function secondaryMarketLiveInstantBookWorkflowRejected(orderId: string, error: string | undefined) {
  return {
    type: 'SECONDARY_MARKET_LIVE_INSTANT_BOOK_REJECTED' as const,
    orderId,
    error,
  };
}
export type SecondaryMarketLiveInstantBookWorkflowRejected = ReturnType<
  typeof secondaryMarketLiveInstantBookWorkflowRejected
>;
